/* Pure display policy. Browser storage and DOM are supplied by the controller. */
(function (root) {
  const SESSION_MS = 30 * 60 * 1000;
  const DISMISS_MS = 30 * 24 * 60 * 60 * 1000;
  function visit(previous, path, now) {
    const valid = previous && Array.isArray(previous.paths) && Number.isFinite(previous.at) && now >= previous.at && now - previous.at < SESSION_MS;
    const paths = valid ? previous.paths.filter(p => typeof p === 'string').slice(-100) : [];
    return { paths: [...new Set([...paths, path.replace(/\/+$/, '') || '/'])], at: now };
  }
  function eligible(visitState, preference, now) {
    return !!visitState && Array.isArray(visitState.paths) && visitState.paths.length >= 4 && Number.isFinite(visitState.at) && now >= visitState.at && now - visitState.at < SESSION_MS && preference.subscribed !== true && !(Number.isFinite(preference.until) && preference.until > now);
  }
  const policy = { visit, eligible, DISMISS_MS };
  if (typeof module !== 'undefined' && module.exports) module.exports = policy;
  else root.MhlNewsletterPolicy = policy;
})(typeof window !== 'undefined' ? window : globalThis);
